<template>
	<v-layout
		row
		wrap
		justify-center
	>
		<v-flex xl8>
			<v-data-iterator
				ref="iterator"
				:items="items"
				:pagination.sync="pagination"
				:hide-actions="items.length === 0"
				no-data-text="No overrides available"
				no-results-text="No matching overrides found"
				content-tag="v-layout"
				row
				wrap
				justify-center
			>
				<v-flex
					slot="item"
					slot-scope="props"
					xs12
				>
					<v-card>
						<v-container>
							<v-layout
								row
								wrap
								align-center
								justify-end
								px-3
							>
								<v-flex xs12 sm6 md3>
									<v-text-field
										label="When"
										:value="props.item.filterModelType"
										disabled
									></v-text-field>
								</v-flex>
								<v-flex xs12 sm6 md3>
									<v-text-field
										label="Equals"
										:value="props.item.filterModelId"
										disabled
									></v-text-field>
								</v-flex>
								<v-flex xs12 sm6 md3>
									<v-text-field
										label="Then Set"
										:value="`${props.item.overrideModelType}.${props.item.attribute}`"
										disabled
									></v-text-field>
								</v-flex>
								<v-flex xs12 sm6 md3>
									<v-text-field
										label="To"
										:value="props.item.value"
										disabled
									></v-text-field>
								</v-flex>
								<v-spacer />
								<div v-if="canEdit">
									<v-btn
										flat
										@click="$emit('update', props.item)"
									>
										Update
									</v-btn>
									<v-btn
										flat
										color="error"
										@click="$emit('delete', props.item)"
									>
										Delete
									</v-btn>
								</div>
							</v-layout>
							
							
						</v-container>
					</v-card>
				</v-flex>
			</v-data-iterator>
		</v-flex>
	</v-layout>
</template>

<script>
//import CustomFieldItems from '@/components/Project/CustomFields/CustomFieldItems';

export default {
	components: {
		//CustomFieldItems,
	},
	props: {
		items: {
			type: Array,
			default: null
		},
	},
	data() {
		return {
			pagination: {
				rowsPerPage: 12,
				sortBy: 'name',
				descending: false,
				page: 1,
			},
		};
	},
	computed: {
		project() {
			return this.$store.get('projects/currentProject');
		},
		canEdit() {
			return this.project.userCan('manage_custom_data') && !this.project.isArchived;
		},
	},
};
</script>

<style lang="scss" scoped>
.small-btn {
	margin-top: 0;
	margin-right: -10px;
	margin-bottom: 0;
}
.absolute--right {
	position: absolute;
	top: 0;
	right: 0;
}
</style>
